import { referenceBenchmarks, type ApiClient, type ReferenceBenchmarks } from '@aithora/shared';
import { useQuery, type QueryState } from './useQuery';

/**
 * THE reference figures every console chart line and "national" note reads: the server's
 * reference-benchmarks module (CMS Care Compare US averages and our catalog's occupancy
 * quartiles), each with its source and date. A page never writes its own national figure;
 * while this is loading or unavailable the line is simply not drawn.
 */
export function useReferenceBenchmarks(client: ApiClient, enabled = true): QueryState<ReferenceBenchmarks> {
  return useQuery<ReferenceBenchmarks>((signal) => referenceBenchmarks(client, { signal }), [client], { enabled });
}

/** "US median 84.2% (CMS catalog, 2026-10-12)", or null when the catalog has no figure. */
export function occupancyNote(b: ReferenceBenchmarks | null | undefined): string | null {
  const o = b?.occupancy;
  if (!o) return null;
  return 'US median ' + o.median + '% (CMS catalog' + (o.asOf ? ', ' + o.asOf : '') + ')';
}
